<script>
    import { maintenanceOverride } from '$stores/maintenanceOverride';

    export let message = 'The site is currently undergoing maintenance. Please check back later.';

    let password = '';
    let error = '';

    function unlock() {
        if (password === import.meta.env.VITE_MAINTENANCE_PASSWORD) {
            maintenanceOverride.set(true);
        } else {
            error = 'Incorrect password';
        }
    }
</script>

<div class="maintenance-page">
    <h1>We'll be back soon</h1>
    <p>{message}</p>
    <input type="password" bind:value={password} placeholder="Password" />
    <button on:click={unlock}>Enter</button>
    {#if error}
        <p class="error">{error}</p>
    {/if}
</div>

<style lang="scss">
.maintenance-page {
    padding: 8rem 2rem;
    text-align: center;
    input {
        margin-top: 1rem;
        padding: 0.5rem;
    }
    button {
        margin-left: 0.5rem;
        padding: 0.5rem 1rem;
    }
    .error {
        color: red;
        margin-top: 0.5rem;
    }
}
</style>
